import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MentionsLegales = () => {
  return (
    <div className="bg-gray-950 text-white min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <div className="inline-block px-4 py-1 border border-flowkraft-primary/30 text-flowkraft-secondary text-sm mb-6">
              Légal
            </div>
            <h1 className="font-display text-display text-white mb-6">
              Mentions Légales
            </h1>
            <p className="text-xl text-gray-400">
              Informations légales concernant FlowKraft Agency
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-12">

          {/* Éditeur du site */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              1. Éditeur du site
            </h2>
            <div className="text-gray-400 space-y-2">
              <p>
                <span className="text-gray-300">Raison sociale :</span> FlowKraft Agency
              </p>
              <p>
                <span className="text-gray-300">Forme juridique :</span> Micro-entreprise
              </p>
              <p>
                <span className="text-gray-300">Adresse :</span> Toulouse, France
              </p>
              <p>
                <span className="text-gray-300">Email :</span>{" "}
                <a
                  href="mailto:info@flowkraftagency.com"
                  className="text-flowkraft-secondary hover:underline"
                >
                  info@flowkraftagency.com
                </a>
              </p>
              <p>
                <span className="text-gray-300">Téléphone :</span>{" "}
                <a
                  href="tel:+33652794562"
                  className="text-flowkraft-secondary hover:underline"
                >
                  +33 (0)6 52 79 45 62
                </a>
              </p>
              <p>
                <span className="text-gray-300">Directeur de la publication :</span> FlowKraft Agency
              </p>
            </div>
          </div>

          {/* Hébergement */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              2. Hébergement
            </h2>
            <div className="text-gray-400 space-y-2">
              <p>
                <span className="text-gray-300">Hébergeur :</span> LWS
              </p>
              <p>
                <span className="text-gray-300">Site web :</span>{" "}
                <a
                  href="https://www.lws.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-flowkraft-secondary hover:underline"
                >
                  https://www.lws.fr
                </a>
              </p>
            </div>
          </div>

          {/* Propriété intellectuelle */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              3. Propriété intellectuelle
            </h2>
            <p className="text-gray-400 mb-4 leading-relaxed">
              L'ensemble de ce site relève de la législation française et
              internationale sur le droit d'auteur et la propriété
              intellectuelle. Tous les droits de reproduction sont réservés, y
              compris pour les documents téléchargeables et les représentations
              iconographiques et photographiques.
            </p>
            <p className="text-gray-400 leading-relaxed">
              La reproduction de tout ou partie de ce site sur un support
              électronique quel qu'il soit est formellement interdite sauf
              autorisation expresse du directeur de la publication.
            </p>
          </div>

          {/* Protection des données */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              4. Protection des données personnelles
            </h2>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Conformément à la loi "Informatique et Libertés" du 6 janvier 1978
              modifiée et au Règlement Général sur la Protection des Données
              (RGPD), vous disposez d'un droit d'accès, de rectification, de
              suppression et d'opposition aux données personnelles vous
              concernant.
            </p>
            <p className="text-gray-400 leading-relaxed">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse :
              <a
                href="mailto:info@flowkraftagency.com"
                className="text-flowkraft-secondary hover:underline ml-1"
              >
                info@flowkraftagency.com
              </a>
            </p>
            <p className="text-gray-400 mt-4 leading-relaxed">
              Pour plus d'informations, consultez notre{" "}
              <Link
                to="/politique-confidentialite"
                className="text-flowkraft-secondary hover:underline"
              >
                Politique de confidentialité
              </Link>
              .
            </p>
          </div>

          {/* Cookies */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              5. Cookies
            </h2>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Ce site peut utiliser des cookies pour améliorer l'expérience
              utilisateur. Les cookies sont de petits fichiers texte stockés sur
              votre ordinateur par votre navigateur web.
            </p>
            <p className="text-gray-400 leading-relaxed">
              Vous pouvez configurer votre navigateur pour refuser les cookies.
              Cependant, cela peut affecter certaines fonctionnalités du site.
            </p>
          </div>

          {/* Liens hypertextes */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              6. Liens hypertextes
            </h2>
            <p className="text-gray-400 leading-relaxed">
              Les liens hypertextes mis en place dans le cadre du présent site
              internet en direction d'autres ressources présentes sur le réseau
              Internet ne sauraient engager la responsabilité de FlowKraft
              Agency.
            </p>
          </div>

          {/* Limitation de responsabilité */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              7. Limitation de responsabilité
            </h2>
            <p className="text-gray-400 mb-4 leading-relaxed">
              FlowKraft Agency ne pourra être tenue responsable des dommages
              directs et indirects causés au matériel de l'utilisateur, lors de
              l'accès au site, et résultant soit de l'utilisation d'un matériel
              ne répondant pas aux spécifications indiquées, soit de
              l'apparition d'un bug ou d'une incompatibilité.
            </p>
            <p className="text-gray-400 leading-relaxed">
              FlowKraft Agency ne pourra également être tenue responsable des
              dommages indirects consécutifs à l'utilisation du site.
            </p>
          </div>

          {/* Droit applicable */}
          <div className="mb-16">
            <h2 className="font-display text-2xl text-white mb-6">
              8. Droit applicable
            </h2>
            <p className="text-gray-400 leading-relaxed">
              Les présentes mentions légales sont régies par le droit français.
              En cas de litige et à défaut d'accord amiable, le litige sera
              porté devant les tribunaux français conformément aux règles de
              compétence en vigueur.
            </p>
          </div>

          {/* Date de mise à jour */}
          <div className="text-gray-500 text-sm border-t border-white/10 pt-8">
            <p>
              Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative">
        <div className="absolute inset-0 opacity-10">
          <img
            src="/images/main/2149755776.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 text-center">
          <h2 className="font-display text-title text-white mb-6">
            Des questions ?
          </h2>
          <p className="text-gray-400 text-lg mb-8 max-w-xl mx-auto">
            N'hésitez pas à nous contacter pour toute information complémentaire
          </p>
          <Link
            to="/#contact"
            className="btn-solid inline-flex"
          >
            Nous contacter
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
